import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCheckInTasks({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.8 11.8a.7.7 0 01.1 1.4H3.5a.7.7 0 01-.1-1.4h10.4zM6.34 6.48c.26.27.28.69.05.98l-.07.08-2.35 2.25a.75.75 0 01-.96.06l-.09-.07-1.45-1.46a.75.75 0 01.98-1.13l.08.07.94.94 1.81-1.74a.75.75 0 011.06.02zM13.8 7.8a.7.7 0 01.1 1.4H8.2a.7.7 0 01-.1-1.4h5.7zM6.34 2.48c.26.27.28.69.05.98l-.07.08L3.97 5.8a.75.75 0 01-.96.06l-.09-.07-1.45-1.46a.75.75 0 01.98-1.13l.08.07.94.94 1.81-1.74a.75.75 0 011.06.02zM13.8 3.8a.7.7 0 01.1 1.4H8.2a.7.7 0 01-.1-1.4h5.7z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicCheckInTasks.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCheckInTasks.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicCheckInTasks svgRef={ref} {...props} />
));
export default ForwardRef;
